import { DateRange } from '@angular/material/datepicker';
import { FilterCodec, FormatedSavedFilter, SavedFilterService } from '@teammood/filter';
import { StatsService } from './stats.service';
import { MoodsByDay } from '../graphs/utils.type';
import {
    PieChartData
} from 'app/frontend/lib/analytics/graphs/mood-distribution-for-entire-period/mood-distribution-for-entire-period.component';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoggerService } from '@teammood/shared/util/logger';
import { addDays, format, parse } from "date-fns";
import { SavedFilterChange } from "../../filter/saved-filter/saved-filter.component";
import { ActivatedRoute } from "@angular/router";
import { Subject, takeUntil, tap } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'stats',
    templateUrl: './stats.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatsComponent implements OnInit, OnDestroy {

    pageTitle = 'Analytics';
    showSpinner = false;
    dateInterval: DateRange<Date>;
    best_day: string;
    mood_global_average: number;
    worst_day: string;
    url_params: string;
    selectedFilter: FormatedSavedFilter;
    moodDistributionDistributionChartData: MoodsByDay[];
    moodDistributionPieChartData: PieChartData;

    protected range: string;

    private _destroy$ = new Subject<void>();

    constructor(
        private logger: LoggerService, 
        private statsService: StatsService, 
        private savedFilterService: SavedFilterService,
        private filterCodec: FilterCodec,
        private route: ActivatedRoute,
        private translate: TranslateService,
    ) {
    }

    async ngOnInit() {

        this.route.queryParams.pipe(
            tap(async params => {
                const start = params['start'];
                const end = params['end'];

                const filter = params['filter'];

                this.showSpinner = true;

                if (start && end) {
                    const dateRangeFromUrl: DateRange<Date> = new DateRange(parse(start, 'dd-MM-yyyy', new Date()), parse(end, 'dd-MM-yyyy', new Date()));
                    this.savedFilterService.saveDateRange(dateRangeFromUrl);
                } else {
                    this.savedFilterService.saveDateRange(new DateRange<Date>(addDays(new Date(), -30), new Date()));
                }

                this.dateInterval = this.savedFilterService.getDateRange()

                if (filter) {
                    this.savedFilterService.saveFilter(this.filterCodec.decode(filter));
                }

            }),
            takeUntil(this._destroy$)
        ).subscribe();

        this.translate.get('analytics.bubbleChart.day').pipe(
            tap(translation => {
                this.range = translation;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    async onFilterChange(change: SavedFilterChange) {
        this.dateInterval = change.dateInterval ? change.dateInterval : this.dateInterval;
        const encodedFilter = this.filterCodec.encode(change.filter.decodedFilter);
        await this.loadStats(format(this.dateInterval.start, 'dd-MM-yyyy'), format(this.dateInterval.end, 'dd-MM-yyyy'), encodedFilter);
    }

    async loadStats(start: string, end: string, filter: string) {

        this.showSpinner = true;
        try {

            this.url_params = `start=${start}&end=${end}&filter=${filter}`;

            this.moodDistributionDistributionChartData = await this.statsService.moods_distribution_by_day(this.url_params);
            this.moodDistributionPieChartData = await this.statsService.mood_distribution_for_entire_period(this.url_params);
            this.best_day = await this.statsService.best_day(this.url_params);
            this.worst_day = await this.statsService.worst_day(this.url_params);
            this.mood_global_average = Math.round(await this.statsService.global_average(this.url_params) * 10) / 10;
            
        } catch (error) {
            this.logger.error(error);
        }
        this.showSpinner = false;
    }

    protected onChangeRange(range: string) {
        this.range = this.translate.instant(`analytics.bubbleChart.${range}`);
    }
}